import React, { useContext, useState } from 'react'
import cardImg from "../assets/images/cardImg.svg";
import blue_email from "../assets/images/blue_email.svg";
import { AppContext } from '../contaxt/AppContext';
import ShieldQuestion from "../assets/images/sheildWhite.svg";
import AccessTime from "../assets/images/clockWhite.svg";
import nextplan from "../assets/images/nextplan.svg";
import { useNavigate } from 'react-router-dom';
import thumbsup from "../assets/images/thumbs-up.svg";
import activeThumsUp from "../assets/images/activeThumsUp.svg";
import thumbsdown from "../assets/images/thumbs-down.svg";
import activethumpsdown from "../assets/images/thumbsdownWhitediff.svg";
import Satisfied from "../assets/images/satisfied.svg";
import Enthusiastic from "../assets/images/Enthusiastic.svg";
import Diplomatic from "../assets/images/diplomatic.svg";
import Cautious from "../assets/images/Cautious.svg";
import arrowRight from "../assets/images/arrow-right.svg";
import saveIcon from "../assets/images/Save.svg";
import languageIcon from "../assets/images/languageBlue.svg";
import mobSaveIcon from "../assets/images/SaveBlue.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import closeIcon from "../assets/images/closeIcon.svg";


export default function InternalBehavioralAssessment() {
    const navigate = useNavigate();
    const { isNormal } =
        useContext(AppContext);

    const [showLanguagePopup, setShowLanguagePopup] = useState(false);

    const languages = Array(12).fill("English");

    const [showExitModal, setShowExitModal] = useState(false);

    return (
        <>

            <div className="paGeWrap m-botm">
                <div className='container colCntR'>
                    <h3>Dear Hari Prasad Chauhan</h3>
                    <h4>Your Internal Assessment is Ready</h4>
                    <div className="col-12 col-md-10 col-lg-8 emailNotifiTxt mobBgWrap3">
                        <p>Take a moment to read the instructions, then start your Behavior Assessment</p>
                    </div>

                    <div className='col-12 col-md-10 col-lg-8'>
                        <div className='behavr-box-wrap'>
                            <div className='behavr-txt-box'>
                                <h2 className='next-step-lywo'>Internal Behavioral Assessment</h2>
                                <div className="qstInnfo">
                                    <div className="inFo-itm">
                                        <img src={ShieldQuestion} className="icon-green-box" alt="" />
                                        <span>28 Questions Set</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={AccessTime} className="icon-green-box" alt="" />
                                        <span>10 Minutes</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={activeThumsUp} className="thumbsup-actv-box" alt="Thumbs Up" />
                                        <span>Select 1 "Most Like You" For every set</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={activethumpsdown} className="thumbsdown-actv-box" alt="Thumbs Down" />
                                        <span>Select 1 "Least Like You" For every set</span>
                                    </div>
                                </div>

                            </div>
                            <div className='ARW-sec-flshScrn'>
                                <h5>Answering the Right Way :</h5>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: '20px' }}>

                                    <div className='cardCOlsx'>

                                        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexWrap: 'wrap', gap: 20, marginBottom: '20px' }}>
                                            <div className="card-sx cardwdtH-sx" style={{ border: `1px solid #444CE7` }}>
                                                <div className='card-inside-wrap'>
                                                    <img src={Cautious} className="card-img-sx" alt="" />
                                                    <div>
                                                        <p>Daring</p>
                                                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                            <img
                                                                src={thumbsdown}
                                                                className='thumbsdown-box'
                                                                alt="Thumbs Down"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <img
                                                                src={activeThumsUp}
                                                                className='thumbsup-box-actv'
                                                                alt="Thumbs Up"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-sx cardwdtH-sx" style={{ border: `1px solid #F97066` }}>
                                                <div className='card-inside-wrap'>
                                                    <img src={Satisfied} className="card-img-sx" alt="" />
                                                    <div>
                                                        <p>Satisfied</p>
                                                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                            <img
                                                                src={activethumpsdown}
                                                                className='thumbsdown-box-actv'
                                                                alt="Thumbs Down"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <img
                                                                src={thumbsup}
                                                                className='thumbsup-box'
                                                                alt="Thumbs Up"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexWrap: 'wrap', gap: 20, marginBottom: '20px' }}>
                                            <div className="card-sx cardwdtH-sx" style={{ border: `1px solid #FFFFFF` }}>
                                                <div className='card-inside-wrap'>
                                                    <img src={Enthusiastic} className="card-img-sx" alt="" />
                                                    <div>
                                                        <p>Enthusiastic</p>
                                                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                            <img
                                                                src={thumbsdown}
                                                                className='thumbsdown-box'
                                                                alt="Thumbs Down"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <img
                                                                src={thumbsup}
                                                                className='thumbsup-box'
                                                                alt="Thumbs Up"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-sx cardwdtH-sx" style={{ border: `1px solid #FFFFFF` }}>
                                                <div className='card-inside-wrap'>
                                                    <img src={Diplomatic} className="card-img-sx" alt="" />
                                                    <div>
                                                        <p>Good Natured</p>
                                                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                            <img
                                                                src={thumbsdown}
                                                                className='thumbsdown-box'
                                                                alt="Thumbs Down"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <img
                                                                src={thumbsup}
                                                                className='thumbsup-box'
                                                                alt="Thumbs Up"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="answr-box">
                                        <h5 className='mb-1'>Your Answer</h5>
                                        <div className='mb-2'>
                                            <p>Most Like Me:</p>
                                            <h6 className='most-like-colr'>Daring</h6>
                                        </div>
                                        <div>
                                            <p>Least Like Me:</p>
                                            <h6 className='least-like-colr'>Satisfied</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='neWbTnAreaWrap'>
                                <div className="btnLywo1" onClick={() => navigate("")}>
                                    <p>Let’s Start the Test</p>
                                    <img src={arrowRight} className="mobIcon" alt="About Company" />
                                </div>
                                <div className="btnLywo2" onClick={() => setShowExitModal(true)} >
                                    <p>Return Later to complete</p>
                                    <img src={saveIcon} className="mobIcon" alt="About Company" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showExitModal && (
                    <div className="mcq-sbmt-modal-overlay">
                        <div className="mcq-sbmt-modal-content">
                            <div className="modal-top-close-btn">
                                <img src={closeIcon} className="mobIcon" alt="" onClick={() => setShowExitModal(false)} />
                            </div>

                            <div className="mcq-sbmt-modal-header">
                                <h4>Your progress has been saved</h4>
                            </div>
                            <div className="mcq-sccs-txt">
                                <p>
                                    You can return anytime to complete the test.
                                </p>
                            </div>

                            <div
                                className="mcq-sbmt-exit-btn"
                                onClick={() => {
                                    setShowExitModal(false);
                                    navigate("/Lywocode");
                                }}
                            >
                                <p>Save & Exit</p>
                            </div>
                        </div>
                    </div>
                )}

                {showLanguagePopup && (
                    <div className="langPopup-overlay" onClick={() => setShowLanguagePopup(false)}>
                        <div className="langPopup-content" onClick={(e) => e.stopPropagation()}>
                            <div className="langPopup-header">
                                <img src={languageIcon} className="mobIcon" alt="Select language" />
                                <p>Select Language</p>
                            </div>
                            <ul className="lang-list">
                                {languages.map((lang, index) => (
                                    <li key={index} className="lang-item" onClick={() => setShowLanguagePopup(false)}>{lang}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                <div className="mobile-icons">
                    <div className="mobile-icon-txt" onClick={() => setShowLanguagePopup(true)}>
                        <img src={languageIcon} className="mobIcon" alt="Select language" />
                        <p>Select language</p>
                    </div>
                    <div className="mobile-icon-txt" onClick={() => setShowExitModal(true)}>
                        <img src={mobSaveIcon} className="mobIcon" alt="Save & Exit" />
                        <p>Save & Exit</p>
                    </div>
                    <div className="mobile-icon-txt" onClick={() => navigate("/InternalAssessmentForm")}>
                        <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
                        <p>Edit Profile</p>
                    </div>
                </div>
            </div>
        </>

    )
}
